import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios'
import CloseIcon from '@mui/icons-material/Close';
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";

import './drop-file-input.css';

import { ImageConfig } from '../../config/ImageConfig';
import uploadImg from '../../assets/cloud-upload-regular-240.png';
import { UploadContext } from '../Modals/UploadManual';

const DropFileInput = (props) => {
    const [percentage, setPercentage] = React.useState("0");
    const [modal4, setModal4, getData] = React.useContext(UploadContext);
    const wrapperRef = useRef(null);
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [progress, setProgress] = useState(0);
    const [state, setState] = useState("Uploading");

    // const modal4 = props.modal4
    // const setModal4 = props.setModal4

    const [fileList, setFileList] = useState([]);


    const onDragEnter = () => wrapperRef.current.classList.add('dragover');

    const onDragLeave = () => wrapperRef.current.classList.remove('dragover');

    const onDrop = () => wrapperRef.current.classList.remove('dragover');

    const onFileDrop = (e) => {
        const newFile = e.target.files[0];
        // console.log(newFile)
        if (newFile && fileList.length === 0) {
            const updatedList = [...fileList, newFile];
            setFileList(updatedList);
            props.onFileChange(updatedList);
        }
    };

    const fileRemove = (file) => {
        const updatedList = [...fileList];
        updatedList.splice(fileList.indexOf(file), 1);
        setFileList(updatedList);
        props.onFileChange(updatedList);
    };

    const submitVideo = () => {
        setIsProcessing(true)
        // console.log(fileList[0])
        // console.log("Started uploading xlsx")
        const formData = new FormData();
        formData.append("video", fileList[0]);

        let data = axios.post('/api/upload', formData, {
            headers: {
                Authorization: 'Bearer ' + sessionStorage.getItem('userToken'),
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (data) => {
                //Set the progress value to show the progress bar
                setProgress(parseFloat(((100 * data.loaded) / data.total).toFixed(2)));
            },
        })
            .then(response => {

                // console.log(response);
                showSuccessToast(
                    (response.data && response.data.Message) ? response.data.Message : "Success"
                );
                // props.setModal4(false);


                setIsProcessing(false)
                setModal4(!modal4)
                getData()

            })
            .then(() => {
                setFileList([])
            })
            .catch(error => {
                // Handle error

                showErrorToast("Error in Uploading Video");
                setIsProcessing(false)

                console.error(error);
                // props.setModal4(false);
            });
        console.log("Ending uploading xlsx")

    }
    React.useEffect(() => {

        if (state === "Compiling") {
            // console.log("inside socket use effect");
            const socket = new WebSocket("wss://feeds.playstream.media/websocket");

            // const socket = new WebSocket("ws://localhost:8004/websocket");
            // const socket = new WebSocket("ws://192.168.1.9:8004");


            socket.onopen = () => {
                console.log("WebSocket connected123");
            };

            let data = 0;
            socket.onmessage = (event) => {
                let message = JSON.parse(event.data);
                // console.log(message)
                if (message.type == 'manual') {
                    // console.log(message)
                    setPercentage(message.data);
                }
            };
            return () => {
                socket.close();
            };
        }

    }, [state]);

    useEffect(() => {

        if (progress === 100) {
            setState("Compiling")
        }

    }, [progress])

    return (
        <div>
            <div
                ref={wrapperRef}
                className="drop-file-input"
                onDragEnter={onDragEnter}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
            >
                <div className="drop-file-input__label">
                    <img src={uploadImg} alt="" />
                    <p>Drag & Drop your file here</p>
                </div>
                <input type="file" accept=".mp4" value="" onChange={onFileDrop} />
            </div>
            {fileList.length > 0 && (
                <div className="drop-file-preview">
                    <p className="drop-file-preview__title">Ready to upload</p>
                    {fileList.map((item, index) => (
                        <>
                            <div className="drop-file-preview__item_ _info">
                                <>{item.name}</><br />
                                <>{Math.floor((item.size) / (1024 * 1024))} MB</>
                            </div>
                            {!isProcessing ? (

                                <div key={index} className="drop-file-preview__item">

                                    <span className="drop-file-preview__item__del h1" onClick={() => fileRemove(item)}>
                                        <CloseIcon />
                                    </span>
                                </div>
                            ) : (
                                <>
                                    <div key={index} className="drop-file-preview__item"
                                        style={{
                                            width: `${state === "Uploading" ? progress : percentage}%`,
                                            backgroundColor: `${state === "Uploading" ? "#5BC0F8" : "#90EE90"}`,
                                            transition: "width 1s ease-in-out",
                                            paddingRight: "4px",
                                            color: "#333",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <div className="drop-file-preview__item_ _info"
                                        >
                                            <>{state} - {state === "Uploading" ? progress : percentage}%</>
                                        </div>

                                    </div>
                                </>
                            )
                            }
                        </>


                    ))}
                </div>
            )}
            {
                fileList.length > 0 && (
                    <div className='mx-auto d-flex flex-column justify-content-center align-items-center'>

                        <button
                            type="button"
                            onClick={submitVideo}
                            className="btn btn-info btn-md mx-auto px-5"
                            disabled={isProcessing}
                        >
                            {isProcessing ? (
                                <div className='d-flex flex-row justify-content-center'>
                                    <span className="spinner-border spinner-border-sm me-2 mx-2 my-2" role="status" aria-hidden="true" />
                                    <span className='mt-1'>Processing...</span>
                                </div>
                            ) : (
                                'Upload Video'
                            )}
                        </button>
                    </div>

                )
            }
        </div>
    );
};

DropFileInput.propTypes = {
    onFileChange: PropTypes.func,
};

export default DropFileInput;
